import { Icon, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { useBillIntegrationStatusTooltipMessageKey } from '@views/bills/hooks/useBillIntegrationStatusKey'

import { CegidIntegrationStatus as CegidIntegrationStatusType } from '../../../cegidIntegration/enums/cegidIntegrationStatus'
import { cegidIntegrationStatusToIcon } from '../../constants/cegidIntegrationStatusToIcon'
import { cegidIntegrationStatusToTranslationKeys } from '../../constants/cegidIntegrationStatusToTranslationKeys'

interface CegidIntegrationStatusProps {
  integrationStatus: IntegrationStatus
}

export const CegidIntegrationStatus = ({ integrationStatus }: CegidIntegrationStatusProps): ReactElement | null => {
  const { t } = useTranslation()

  const { status } = integrationStatus
  const tooltipTKey = useBillIntegrationStatusTooltipMessageKey(integrationStatus)
  const { icon, color } = cegidIntegrationStatusToIcon[status]

  if (!tooltipTKey || !icon || !color) {
    return null
  }

  return (
    <Tooltip label={t(tooltipTKey)} placement="top">
      <Icon icon={icon} color={color} />
    </Tooltip>
  )
}

export const SimpleCegidIntegrationStatus = ({
  status,
}: {
  status: CegidIntegrationStatusType
}): ReactElement | null => {
  const { t } = useTranslation()

  const tooltipTKey = cegidIntegrationStatusToTranslationKeys[status]
  const { icon, color } = cegidIntegrationStatusToIcon[status]

  if (!tooltipTKey || !icon || !color) {
    return null
  }

  return (
    <Tooltip label={t(tooltipTKey)} placement="top">
      <Icon icon={icon} color={color} />
    </Tooltip>
  )
}
